import useAdditionalOrderViewModel from './hooks/AdditionalOrderViewModel';
import AdditionalOrderView from './ui/AdditionalOrderView';

export { AdditionalOrderView, useAdditionalOrderViewModel };
